<template>
	<div class="filters-box">
		<div class="filters-box-row">
			<div class="data-picker-box">
				<span>时间周期：</span>
				<el-date-picker
					v-model="dateValue"
					size="small"
					type="daterange"
					align="right"
					:clearable='false'
					unlink-panels
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					value-format="yyyy-MM-dd">
				</el-date-picker>
			</div>
			<div class="order-type-box">
				<span>单据类型：</span>
				<el-select v-model="orderType" placeholder="请选择单据类型" class="order-type-select" size="small">
					<el-option
						v-for="item in options"
						:key="item.value"
						:label="item.value"
						:value="item.value">
					</el-option>
				</el-select>
			</div>
			<div class="order-NO-box">
				<span>单据编号：</span>
				<el-input v-model="orderNOValue" placeholder="请输入单据编号" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
		</div>
		<div class="filters-box-row">
			<div class="order-group-box">
				<span>采购门店名称：</span>
				<el-input v-model="orderGroupValue" placeholder="请输入采购门店名称" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-shop-box">
				<span>供货商店铺名称：</span>
				<el-input v-model="orderShopValue" placeholder="请输入供货商店铺名称" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'FiltersBox',
	data () {
		return {
			options: [
				{ value: '全部' },
				{ value: '订单' },
				{ value: '退单' }
			],
			orderType: '全部',
			orderNOValue: '',
			orderGroupValue: '',
			orderShopValue: '',
			dateValue: []
		}
	},
	created () {
		if (!this.$fxUtils.isEmptyObjSHW(this.$route.query)) {
			let throughParams = this.$fxUtils.JSONparse(this.$route.query.throughParams)
			if (throughParams) {
				this.orderGroupValue = (throughParams.entname && throughParams.entname.value) || ''
				this.orderShopValue = (throughParams.shopName && throughParams.shopName.value) || ''
				let startDate = throughParams.startDate.value.split(' ')
				let endDate = throughParams.endDate.value.split(' ')
				this.dateValue = [startDate[0], endDate[0]]
			}
		} else {
			this.dateValue = [this.$fxUtils.getCurrentMonthFirst(), this.$fxUtils.getCurrentMonthLast()]
		}
	},
	methods: {
		inputEnterHandle () {
			this.$emit('inputEnter')
		},
		getFiltersParams () {
			let filtersParams = []
			let cParams = []
			if (this.orderType !== '全部') {
				let orderTypeObj = { 'field': 'orderType', 'data': this.orderType, 'op': 'eq' }
				cParams.push(orderTypeObj)
			}
			if (this.orderNOValue) {
				let orderNoObj = { 'field': 'orderNo', 'data': this.orderNOValue, 'op': 'cn' }
				cParams.push(orderNoObj)
			}
			if (this.dateValue === '' ||
				this.dateValue === null ||
				this.dateValue === undefined) {
				filtersParams = [
					{ field: 'createDate', data: `${this.$fxUtils.getCurrentMonthFirst()} 00:00`, 'op': 'ge' },
					{ field: 'createDate', data: `${this.$fxUtils.getCurrentMonthLast()} 23:59`, 'op': 'le' }
				]
			} else {
				filtersParams = [
					{ field: 'createDate', data: `${this.dateValue[0]} 00:00`, 'op': 'ge' },
					{ field: 'createDate', data: `${this.dateValue[1]} 23:59`, 'op': 'le' }
				]
			}
			if (this.orderGroupValue) {
				let orderGrpupObj = { 'field': 'storename', 'data': this.orderGroupValue, 'op': 'cn' }
				filtersParams.push(orderGrpupObj)
			}
			if (this.orderShopValue) {
				let orderShopObj = { 'field': 'shopName', 'data': this.orderShopValue, 'op': 'cn' }
				filtersParams.push(orderShopObj)
			}
			return {
				filtersParams,
				cParams
			}
		},
		getFiltersDate () {
			return [
				{ name: 'startDate', field: 'createDate', value: `${this.dateValue[0]} 00:00`, 'op': 'ge', type: 'filtersParams' },
				{ name: 'endDate', field: 'createDate', value: `${this.dateValue[1]} 23:59`, 'op': 'le', type: 'filtersParams' }
			]
		}
	}
}
</script>
<style lang="stylus" scoped>
.filters-box {
	width:100%
	.filters-box-row {
		display:flex
		margin-bottom: 10px
		&:last-child {
			margin-bottom: 0px
		}
		.data-picker-box {
			margin-right:10px
		}
		.order-type-box {
			margin-right:10px
			.order-type-select {
				width:150px
			}
		}
		.order-NO-box, .order-group-box, .order-shop-box {
			.order-input {
				width:150px
			}
		}
		.order-group-box {
			margin-right:10px
		}
	}
}
</style>

